import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useCookies } from "react-cookie";
import { getCookie } from "../utils/service";
import RouteConstants from "../constants/routeConstants.json";

const AuthRouteProtection = (props) => {
  const location = useLocation();
  const cookie = getCookie(["x-access-token"]);
  let loadComponent = false;
  let route = RouteConstants.LOGIN;

  if (cookie) {
    loadComponent = true;
  } else {
    route = RouteConstants.LOGIN;
  }

  return (
    <>
      {loadComponent ? (
        <Outlet />
      ) : (
        <Navigate to={route} state={{ from: location }} replace />
      )}
    </>
  );
};

export default AuthRouteProtection;
